export const monthlyLedgerReportTableHeader=(fyYear)=>{
    const year=fyYear.split("-")
     let dummyData = [
        {
          label: `Apr${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `May${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Jun${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Jul${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Aug${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Sep${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Oct${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Nov${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Dec${year[0]}`,
          value: `Apr${year[0]}`
        },
        {
          label: `Jan${year[1]}`,
          value: year[1]
        },
        {
          label: `Feb${year[1]}`,
          value: year[1]
        },
        {
          label: `Mar${year[1]}`,
          value: year[1]
        },
      ];
      return dummyData;
}